export default "__VITE_ASSET__BEXrqST8__"